import { ApiError, apiUrl } from "@/lib/api/client";
import { guardResponse } from "@/lib/api/responseLifecycle";
import { accountConfigSchema, accountSessionSchema } from "../model/schema";

/** 引导与登录有独立请求代次；401 由账户状态机处理，避免递归注销。 */
export async function accountRequest(path: string, signal: AbortSignal, body?: unknown, csrf?: string): Promise<unknown> {
  const headers = new Headers();
  if (body !== undefined) headers.set("Content-Type", "application/json");
  if (csrf) headers.set("X-CSRF-Token", csrf);
  const response = guardResponse(await fetch(apiUrl(`/api/account/${path}`), {
    method: body === undefined ? "GET" : "POST", credentials: "include", cache: "no-store", headers, signal,
    body: body === undefined ? undefined : JSON.stringify(body),
  }), signal);
  signal.throwIfAborted();
  if (!response.ok) { await response.body?.cancel(); throw new ApiError(response.status, "ACCOUNT_REQUEST_FAILED"); }
  return response.json();
}
export async function getAccountConfig(signal: AbortSignal) {
  return accountConfigSchema.parse(await accountRequest("config", signal));
}
export async function getAccountSession(signal: AbortSignal) {
  return accountSessionSchema.parse(await accountRequest("session", signal));
}
